import { animate, state, style, transition, trigger } from '@angular/animations';

export const fillScreenAnimation = trigger('fillScreenAnimation', [
    state('for', style({
        top: '{{ top }}',
        left: 0,
        height: '100%',
        width: '100%',
    }), { params: { top: 0 }}),
    transition('void => for', [
        // tslint:disable-next-line:no-magic-numbers
        animate(150),
    ])
]);
